import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormWithButtons} from '@flexinet/ui-components';

import {ProductLineItem} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<ProductLineItem, 'id'>,
    handleSubmit: (values: ProductLineItem) => Promise<unknown>,
    handleCancel?: () => void
}) => {

    // Returning the promise is what keeps Formik's isSubmitting true (and Save disabled)
    // until the save settles; a fire-and-forget call drops it immediately (§6).
    const onSubmit = (values: ProductLineItem) => handleSubmit(values);

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {} as ProductLineItem;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
